@if (visible()) {
  <!-- Backdrop — click outside the card to close -->
  <div class="fixed inset-0 z-[500] bg-black/50 flex items-center justify-center p-4 overflow-y-auto" (click)="closed.emit()">

    <!-- Relative wrapper — positions the notify dropdown OVER the card without being clipped by overflow-y-auto -->
    <div class="relative w-full max-w-[420px]">

      <!-- Card -->
      <div class="bg-white rounded-xl shadow-2xl flex flex-col max-h-[90vh] overflow-y-auto"
           (click)="$event.stopPropagation()">

        <!-- ─── Management / Service Provider / Contractor ─── -->
        @if (!isResident) {
          <div class="p-6">
            <pa-activate-management-account
              [isServiceProvider]="isServiceProvider"
              [isContractor]="isContractor"
              [userSubType]="userSubTypeValue"
              [targetUser]="targetUserData()"
              (activationCompleted)="onActivationCompleted()"
            />
          </div>
        }

        <!-- ─── Resident / Tenant ─── -->
        @if (isResident) {
          <div class="flex flex-col font-poppins">

            <!-- Header -->
            <div class="flex items-center justify-between px-5 pt-5 pb-2">
              <h1 class="text-[26px] font-bold text-[#192A3E] leading-tight">Verification</h1>
              <button type="button"
                      class="text-[#238EC6] text-[15px] font-semibold bg-transparent border-none cursor-pointer hover:underline"
                      (click)="closed.emit()">
                Back
              </button>
            </div>

            <div class="px-5 pb-4">
              <!-- Badge subtitle -->
              <h2 class="text-[16px] font-bold text-[#192A3E] mb-3">Get A Verified Profile Badge</h2>

              <!-- User info card -->
              <div class="border border-[#E6E9EF] rounded-[10px] p-4 flex items-center gap-3 mb-5">
                @if (profilePicture()) {
                  <img [src]="profilePicture()" alt="avatar"
                       class="w-[50px] h-[50px] rounded-full object-cover flex-shrink-0" />
                } @else {
                  <div class="w-[50px] h-[50px] rounded-full bg-[#9CA3AF] flex items-center justify-center flex-shrink-0 overflow-hidden">
                    <svg fill="white" viewBox="0 0 24 24" class="w-full h-full mt-[8px]">
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                    </svg>
                  </div>
                }
                <div class="flex flex-col min-w-0">
                  <span class="text-[16px] font-bold text-[#192A3E] leading-tight">{{ fullName }}</span>
                  <span class="text-[14px] text-[#757A7D]">{{ mobile }}</span>
                  <span class="text-[14px] text-[#757A7D] truncate">{{ email }}</span>
                </div>
              </div>

              <!-- Steps heading -->
              <h2 class="text-[22px] font-bold text-[#192A3E] mb-4">Get verified in 3 easy steps</h2>

              <!-- Steps timeline -->
              <div class="relative pl-10 pr-2 pb-4">
                <!-- Connector lines -->
                <div class="absolute left-3 top-[65px] h-[85px] w-[1px] bg-[#DDE1E4] z-0"></div>
                <div class="absolute left-3 top-[185px] h-[90px] w-[1px] bg-[#DDE1E4] z-0"></div>

                <!-- Step 1: Docs -->
                <div class="flex items-start gap-4 mt-4 mb-8 relative z-10">
                  <div class="absolute -left-10 flex h-full items-center">
                    @if (!isDocsUploaded()) {
                      <img src="assets/images/management/warning-vector.png" class="w-[26px] h-[26px] object-contain" />
                    } @else {
                      <img src="assets/images/management/check-circle.png" class="w-[26px] h-[26px] object-contain" />
                    }
                  </div>
                  <button type="button"
                          class="w-[80px] h-[90px] rounded-[5px] bg-[#F2F6F8] flex flex-col items-center justify-center flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity border-none p-0"
                          (click)="showUploadDocsPopup.set(true)">
                    <img src="assets/images/management/docs-1.png" alt="Docs" class="w-[40px] h-[40px] object-contain" />
                    <span class="text-[13px] font-semibold text-[#192A3E] mt-1">Docs</span>
                  </button>
                  <div class="flex flex-col justify-center h-[90px]">
                    <span class="text-[16px] font-semibold text-[#757A7D] leading-snug">Upload your<br>profile photo</span>
                  </div>
                </div>

                <!-- Step 2: Payment Method -->
                <div class="flex items-start gap-4 mb-8 relative z-10">
                  <div class="absolute -left-10 flex h-full items-start pt-[32px]">
                    @if (paymentMethodSnoozed()) {
                      <img src="assets/images/management/check-circle.png" class="w-[26px] h-[26px] object-contain" />
                    } @else {
                      <img src="assets/images/management/warning-vector.png" class="w-[26px] h-[26px] object-contain" />
                    }
                  </div>
                  <div class="w-[80px] h-[90px] rounded-[5px] bg-[#F2F6F8] flex flex-col items-center justify-center flex-shrink-0">
                    <img src="assets/images/management/services-1.png" alt="Payment" class="w-[40px] h-[40px] object-contain" />
                    <span class="text-[13px] font-semibold text-[#192A3E] mt-1 text-center leading-tight">Payment<br>Method</span>
                  </div>
                  <div class="flex flex-col flex-1 min-w-0">
                    <span class="text-[16px] font-semibold text-[#757A7D] leading-snug mb-2">Add payment method to simplify transactions</span>
                    <button type="button" class="text-[#238EC6] text-[15px] font-semibold bg-transparent border-none p-0 cursor-pointer text-left w-fit hover:underline"
                            (click)="onAddPaymentLater()">
                      {{ paymentMethodSnoozed() ? 'Snoozed' : 'Add later' }}
                    </button>
                  </div>
                </div>

                <!-- Step 3: Terms checkbox -->
                <div class="flex items-start gap-4 relative z-10 mt-2">
                  <div class="absolute -left-[42px] pt-[22px]">
                    <button type="button"
                            class="w-[25px] h-[25px] border-[2px] border-[#338EC6] rounded-[5px] bg-white flex items-center justify-center cursor-pointer p-0"
                            (click)="agreedToTerms.set(!agreedToTerms())">
                      @if (agreedToTerms()) {
                        <img src="assets/icons/check-1.png" class="w-[18px] h-[17px] object-cover" />
                      }
                    </button>
                  </div>
                  <div class="w-full bg-[#F2F6F8] rounded-[5px] border border-[#EFF3F7] p-4 cursor-pointer"
                       (click)="agreedToTerms.set(!agreedToTerms())">
                    <p class="text-base text-[#475569]  m-0 mb-3">
                      I hereby affirm that I am the individual associated with this account and that the identification submitted is legitimate, accurate, and current. I accept sole responsibility for the veracity of my credentials and acknowledge that any misrepresentation may subject me to applicable legal consequences.
                    </p>
                    <p class="text-base text-[#475569]  m-0">
                      By checking this box, you certify that all information pertaining to your identity is truthful and that you are in compliance with relevant verification standards. You further acknowledge that you remain accountable for maintaining the integrity and authenticity of your account credentials.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Bottom action bar — inside card -->
              <div class="flex items-center justify-around  mt-4">
                <button type="button"
                        class="text-white bg-[#1E87BE] text-[16px] py-4 px-4 rounded-[10px] font-bold  border-none cursor-pointer hover:opacity-80"
                        (click)="onSkipForNow()">
                  Skip for Now
                </button>
                <button type="button"
                        class="text-white text-[16px] font-bold bg-[#1E87BE] py-4 px-4 rounded-[10px] border-none cursor-pointer hover:opacity-80 disabled:opacity-50"
                        [disabled]="isSaving()"
                        (click)="onSubmit()">
                  {{ isSaving() ? 'Submitting...' : 'Submit' }}
                </button>
              </div>
            </div>
          </div>
        }

      </div>

      @if (showNotifySheet()) {
        <div class="fixed inset-0 z-[510]" (click)="dismissNotifySheet()"></div>

        <div class="absolute left-[50px] right-[50px] z-[520] bg-white rounded-[10px] shadow-[0_4px_24px_rgba(0,0,0,0.12)] border border-[#E6E9EF] py-[8px]"
             style="bottom: 100px"
             (click)="$event.stopPropagation()">
          <div class="flex items-center justify-between px-[10px] py-2 border-b border-[#E6E9EF]">
            <span class="text-base font-semibold text-heading">Notify me again</span>
            <button type="button"
                    class="border-none bg-transparent cursor-pointer text-[#90A0B7] hover:text-[#192A3E] text-[20px] leading-none p-0 w-6 h-6 flex items-center justify-center"
                    (click)="dismissNotifySheet()">×</button>
          </div>
          @for (opt of notifyOptions; track opt.value) {
            <button type="button"
                    class="flex items-center justify-between w-full px-[10px] py-2 hover:bg-[#F5F9FF] transition-colors text-left border-none bg-transparent cursor-pointer"
                    (click)="selectedNotifyOption.set(opt.value)">
              <span class="text-base font-semibold text-heading">{{ opt.label }}</span>
              <div class="w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center flex-shrink-0"
                   [class.border-[#238EC6]]="selectedNotifyOption() === opt.value"
                   [class.border-[#C8D0D5]]="selectedNotifyOption() !== opt.value">
                @if (selectedNotifyOption() === opt.value) {
                  <div class="w-[12px] h-[12px] rounded-full bg-[#238EC6]"></div>
                }
              </div>
            </button>
          }
          <button type="button"
                  class="flex items-center justify-center w-full px-[10px] py-2 hover:bg-[#F5F9FF] transition-colors border-none bg-transparent cursor-pointer border-t border-[#E6E9EF]"
                  (click)="onNotifySet()">
            <span class="text-base font-semibold text-[#238EC6]">Set</span>
          </button>
        </div>
      }

    </div>
  </div>

  <!-- Doc upload popup -->
  <div (click)="$event.stopPropagation()">
    <pa-document-upload-popup
      [isVisible]="showUploadDocsPopup()"
      [userId]="userId"
      [userType]="userType"
      (closePopup)="onUploadDocsClose()"
      (saveCompleted)="onUploadDocsClose()"
    />
  </div>

}
